import React, {useState} from "react";
import { motion } from "framer-motion";
import { UserGroupIcon } from "@heroicons/react/24/outline";

//25 Nov 2025
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";

const EtInvestorsCTA = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 25 Nov 2025 - Refined for Unified CTA - ctaSource
  
  // 1 -  Local UI state 
  const [open, setOpen] = useState({ visible: false, source: null }); // 25 Nov 2025 - unified CTA

  return (
    <section
      id="investors-cta"
      // className="py-20 bg-gradient-to-r from-orange-700 via-orange-600 to-orange-500 text-white text-center relative"
      className="py-20 bg-gradient-to-b from-orange-700 via-orange-600 to-black text-white text-center relative"
    >
      {/* Background pattern */}
      {/* <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div> */}
      <div className="absolute inset-0 opacity-80 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

      {/* Main content */}
      <motion.div
        className="relative z-10 max-w-3xl mx-auto px-4"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        {/* Headline */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Partner with Us in Shaping the Future
        </h2>

        {/* Subtext */}
        <p className="text-lg text-orange-100 mb-8">
          Eternity is redefining how leadership, AI, and purpose converge to
          create sustainable growth ecosystems. Join us in accelerating this
          transformation — where human clarity meets exponential performance.
        </p>

        {/* CTA Button */}
        <motion.a
          // href="/#contact"
          onClick={() => setOpen({ visible: true, source: "investors-cta" })} // 25 Nov 2025
          className="inline-flex items-center gap-2 px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition cursor-pointer"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <UserGroupIcon className="h-6 w-6" />
          Connect with Eternity
        </motion.a>
      </motion.div>
      {/* 25 Nov 2025 */}
      {open.visible && (
        <EtModalContactConversation
          open={open}
          onClose={() => setOpen({ visible: false, source: null })}
        />
      )}
    </section>
  );
};

export default EtInvestorsCTA;